import { render, staticRenderFns } from "./FullTextPanel.vue?vue&type=template&id=acd07e6c&scoped=true&"
import script from "./FullTextPanel.vue?vue&type=script&lang=js&"
export * from "./FullTextPanel.vue?vue&type=script&lang=js&"
import style0 from "./FullTextPanel.vue?vue&type=style&index=0&id=acd07e6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd07e6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
